import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import SplashScreen from 'src/components/loading-screen/splash-screen';
// layouts
import MainLayout from 'src/layouts/main/simpletranslate';
import CompactLayout from 'src/layouts/compact';

// ----------------------------------------------------------------------
export const SimpleTranslateHomePage = lazy(() => import('src/pages/home/simpletranslate-home'));
export const SimpleAiHomePage = lazy(() => import('src/pages/home/simpletai-home'));
const Page404 = lazy(() => import('src/pages/404'));
const Maintenance = lazy(() => import('src/pages/maintenance'));
const SalesforceRedirect = lazy(() => import('src/pages/auth/salesforce/salesforce-redirect'));
// Article List
const ArticlesListPage = lazy(() => import('src/pages/articles/list'));
// Aticle Blogs
const TranslateFastBlogPage = lazy(() => import('src/pages/articles/blogs/how-to-translate-fast'));
const STVsSalesforceTranslationBlogPage = lazy(
  () => import('src/pages/articles/blogs/st-vs-salesforce-translation')
);
const AvailableMetadataBlogPage = lazy(
  () => import('src/pages/articles/blogs/available-metadatas-in-st')
);
const HowToSetupSTBlogPage = lazy(() => import('src/pages/articles/blogs/how-to-setup-st'));
const GetStartedWithSTBlogPage = lazy(() => import('src/pages/articles/blogs/get-started-with-st'));
const SimpleTChatAssistantBlogPage = lazy(
  () => import('src/pages/articles/blogs/simplet-chat-assistant')
);
const PromptBuilderVisualAIBlogPage = lazy(
  () => import('src/pages/articles/blogs/prompt-builder-visual-ai')
);
// const AICommandCenterBlogPage = lazy(() => import('src/pages/articles/blogs/ai-command-center'));
// const SimpleTAIUseCaseTrackingBlogPage = lazy(
//   () => import('src/pages/articles/blogs/simplet-ai-use-case-tracking')
// );
const SmartCaseCommentBlogPage = lazy(() => import('src/pages/articles/blogs/smartCaseComment'));
const AIAgentBlogPage = lazy(() => import('src/pages/articles/blogs/aiAgent'));
const SimpleEmailAIBlogPage = lazy(() => import('src/pages/articles/blogs/simpleEmailAI'));
const FileAIBlogPage = lazy(() => import('src/pages/articles/blogs/fileAI'));
const RecordAIBlogPage = lazy(() => import('src/pages/articles/blogs/recordAI'));
const AIServiceBlogPage = lazy(() => import('src/pages/articles/blogs/aiService'));
const DetectLanguageBlogPage = lazy(() => import('src/pages/articles/blogs/detectLanguage'));
const SimpleTTranslateBlogPage = lazy(() => import('src/pages/articles/blogs/simpleTTranslate'));

const TranslationApprovalDisastersBlogPage = lazy(
  () => import('src/pages/articles/blogs/translation-approval-disasters')
);
const SimpleTAIComponentsPerformanceBlogPage = lazy(
  () => import('src/pages/articles/blogs/simplet-ai-components-performance')
);

// const AICommandCenterBlogPage = lazy(() => import('src/pages/articles/blogs/ai-command-center'));
// const SimpleTAIUseCaseTrackingBlogPage = lazy(() => import('src/pages/articles/blogs/simplet-ai-use-case-tracking'));
const SimpleTLLMsHandlerBlogPage = lazy(
  () => import('src/pages/articles/blogs/simple-t-llms-handler-one-dashboard')
);
const SimpleTAIAgentsPerformanceBlogPage = lazy(
  () => import('src/pages/articles/blogs/simplet-ai-agents-performance')
);

// n8n dynamic agent template
const N8nAgentTemplatePage = lazy(() => import('src/pages/articles/blogs/n8n/agent-template'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    element: (
      <CompactLayout>
        <Outlet />
      </CompactLayout>
    ),
    children: [
      { path: '404', element: <Page404 /> },
      { path: 'maintenance', element: <Maintenance /> },
      { path: 'redirect', element: <SalesforceRedirect /> },
    ],
  },
  {
    path: 'articles',
    element: (
      <MainLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </MainLayout>
    ),
    children: [
      // List
      { element: <ArticlesListPage />, index: true },
      // Blogs
      { path: 'translate-fast-with-simple-translate', element: <TranslateFastBlogPage /> },
      {
        path: 'salesforce-translation-vs-simple-translate',
        element: <STVsSalesforceTranslationBlogPage />,
      },
      { path: 'available-metadata-in-simple-translate', element: <AvailableMetadataBlogPage /> },
      { path: 'get-started-with-simple-translate', element: <GetStartedWithSTBlogPage /> },
      { path: 'how-to-setup-simple-translate', element: <HowToSetupSTBlogPage /> },
      { path: 'simplet-chat-assistant', element: <SimpleTChatAssistantBlogPage /> },
      { path: 'prompt-builder-visual-ai-integration', element: <PromptBuilderVisualAIBlogPage /> },
      { path: 'translation-approval-disasters', element: <TranslationApprovalDisastersBlogPage /> },
      // { path: 'ai-command-center', element: <AICommandCenterBlogPage /> },
      // { path: 'simplet-ai-use-case-tracking', element: <SimpleTAIUseCaseTrackingBlogPage /> },
      { path: 'smart-case-comment', element: <SmartCaseCommentBlogPage /> },
      { path: 'ai-agent', element: <AIAgentBlogPage /> },
      { path: 'simple-email-ai', element: <SimpleEmailAIBlogPage /> },
      { path: 'file-ai', element: <FileAIBlogPage /> },
      { path: 'record-ai', element: <RecordAIBlogPage /> },
      { path: 'ai-service', element: <AIServiceBlogPage /> },
      { path: 'detect-language', element: <DetectLanguageBlogPage /> },
      { path: 'simplet-translate', element: <SimpleTTranslateBlogPage /> },
      {
        path: 'simplet-ai-components-performance',
        element: <SimpleTAIComponentsPerformanceBlogPage />,
      },

      {
        path: 'simplet-ai-components-performance',
        element: <SimpleTAIComponentsPerformanceBlogPage />,
      },
      { path: 'simplet-ai-agents-performance', element: <SimpleTAIAgentsPerformanceBlogPage /> },
      { path: 'simple-t-llms-handler-one-dashboard', element: <SimpleTLLMsHandlerBlogPage /> },
      // n8n dynamic agent templates
      { path: 'n8n/:id', element: <N8nAgentTemplatePage /> },
    ],
  },
];
